import _ from "lodash";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useStorageState} from "react-storage-hooks";
import {handleApiException, useHttp} from "../../../services/HttpService";
import "../../../styles/components/jahresberichtArbeitsListe.css";
import {useForm} from "../../../utils/FormUtils";
import {changeFieldValueIfPresent} from "../../../utils/ObjectUtils";
import {toBase64QueryParam} from "../../../utils/URLUtils";
import {getDefaultPageInfo, toQueryParams} from "../../../utils/PageInfoUtils";
import usePersonalisationAndPagination from "../usePersonalisationAndPagination";
import JahresberichtArbeitsListeSuche from "./JahresberichtArbeitsListeSuche";
import {getJahresberichtSucheEndpoint} from "../../../services/AnlagenService";
import JahresberichtArbeitsListeTable from "./JahresberichtArbeitsListeTable";

const initialSearchParameters = {
    pageInfo: getDefaultPageInfo("von")
};

function JahresberichtArbeitsListe({
                                       history,
                                       sharedFilter,
                                       onErweiterteSucheOpenChanged,
                                       sharedFormFactory,
                                       regionalstelleOptionen,
                                       raeumlichesKriteriumOptionen,
                                       behoerdeOptionen,
                                       resetSharedFilter,
                                   }) {
    const id = "JahresberichtArbeitsliste";
    const attr = {
        organisation: "organisation",
        betriebsBezeichnung: "betriebsBezeichnung",
        betriebTyp: "betriebTyp",
        anlagenBezeichnung: "anlagenBezeichnung",
        berichtsjahrVon: "berichtsjahrVon",
        berichtsjahrBis: "berichtsjahrBis",
        statusMesswerte: "statusMesswerte",
        statusJahresbericht: "statusJahresbericht",
        kanalzustand: "kanalzustand",
        durchflusspruefung: "durchflusspruefung",
        regionalstelle: "regionalstelle"
    };

    const [selected, setSelected] = useStorageState(sessionStorage, "eab-selected-jahresberichte", []);
    const [storedFilter, setStoredFilter] = useStorageState(sessionStorage, "eab-jahresberichte-filter", initialSearchParameters);

    const {values: filter, setValues: setFilter, formFactory} = useForm({initialValues: storedFilter});

    const createQuery = useCallback((filterObject, sharedFilterObject) => {
        let f = _.cloneDeep(filterObject);
        console.log("SharedFilterObject", filterObject);

        changeFieldValueIfPresent(f, attr.berichtsjahrVon, "id");
        changeFieldValueIfPresent(f, attr.berichtsjahrBis, "id");
        changeFieldValueIfPresent(f, attr.betriebTyp, "id");
        changeFieldValueIfPresent(f, attr.statusMesswerte, "id");
        changeFieldValueIfPresent(f, attr.statusJahresbericht, "id");
        changeFieldValueIfPresent(f, attr.organisation, "id");
        changeFieldValueIfPresent(f, attr.regionalstelle, "id");
        changeFieldValueIfPresent(f, attr.kanalzustand, "id");
        changeFieldValueIfPresent(f, attr.durchflusspruefung, "id");

        if (!f.pageInfo) {
            f.pageInfo = getDefaultPageInfo("jahresberichteId");
        }
        let pageInfoParams = toQueryParams(f.pageInfo);
        delete f.pageInfo;

        delete f.extendedSearchOpen;
        if (Object.keys(f).length === 0) {
            return pageInfoParams;
        }

        return "q=" + toBase64QueryParam(f) + "&" + pageInfoParams;
    }, [attr.berichtsjahrVon, attr.berichtsjahrBis, attr.betriebTyp, attr.organisation, attr.statusJahresbericht, attr.statusMesswerte, attr.regionalstelle, attr.durchflusspruefung, attr.kanalzustand]);

    const initialQuery = useRef(getJahresberichtSucheEndpoint(createQuery({...storedFilter, ...sharedFilter})));
    const [{data, loading}, refetchAnlangen] = useHttp(initialQuery.current, {manual: true});
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (data && data.length > 0) {
            setSelected((prevSelected) => prevSelected.filter((selId) => data.find((dItem) => dItem.id === selId)));
        }
    }, [data, setSelected]);

    const executeSearch = (storedFilterParam, sharedFilterParam) => {
        if (initialized) {
            refetchAnlangen(getJahresberichtSucheEndpoint(createQuery({...storedFilterParam, ...sharedFilterParam}))).catch((e) =>
                handleApiException(e, "Error loading Jahresberichtarbeitsliste")
            );
        }
        setInitialized(true);
    };

    usePersonalisationAndPagination(sharedFilter, storedFilter, executeSearch);

    return (
        <>
            <JahresberichtArbeitsListeSuche
                id={id}
                formFactory={formFactory}
                attr={attr}
                sharedFilter={sharedFilter}
                onErweiterteSucheOpenChanged={onErweiterteSucheOpenChanged}
                sharedFormFactory={sharedFormFactory}
                regionalstelleOptionen={regionalstelleOptionen}
                raeumlichesKriteriumOptionen={raeumlichesKriteriumOptionen}
                behoerdeOptionen={behoerdeOptionen}
                storedFilter={storedFilter}
                setStoredFilter={setStoredFilter}
                setFilter={setFilter}
                resetSharedFilter={resetSharedFilter}
                filter={filter}
                setSelected={setSelected}
                executeSearch={executeSearch}
                initialSearchParameters={initialSearchParameters}
            />
            <JahresberichtArbeitsListeTable
                id={id}
                loading={loading}
                data={data}
                history={history}
                selected={selected}
                setSelected={setSelected}
                storedFilter={storedFilter}
                setStoredFilter={setStoredFilter}
                sharedFilter={sharedFilter}
                createQuery={createQuery}
            />
        </>
    );
}

export default JahresberichtArbeitsListe;
